import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMobileMenuOpen: false,
  isSearchModalOpen: false,
  activeTerminalIndex: 0,
  // The contact form is one modal for the whole app, opened from the header or footer
  isContactOpen: false,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen;
    },
    setMobileMenuOpen: (state, action) => {
      state.isMobileMenuOpen = action.payload;
    },
    toggleSearchModal: (state) => {
      state.isSearchModalOpen = !state.isSearchModalOpen;
    },
    setActiveTerminalIndex: (state, action) => {
      state.activeTerminalIndex = action.payload;
    },
    openContactForm: (state) => {
      state.isContactOpen = true;
      state.isMobileMenuOpen = false;
    },
    closeContactForm: (state) => {
      state.isContactOpen = false;
    },
  },
});

export const {
  toggleMobileMenu,
  setMobileMenuOpen,
  toggleSearchModal,
  setActiveTerminalIndex,
  openContactForm,
  closeContactForm,
} = uiSlice.actions;

export default uiSlice.reducer;
